import React, {useState, useEffect} from 'react';
import { useWeb3 } from '@openzeppelin/network/react';

import { Web3ReactProvider } from '@web3-react/core'
import { Web3Provider } from '@ethersproject/providers'
import { useWeb3React } from '@web3-react/core'
import { InjectedConnector } from '@web3-react/injected-connector'

import {formatEther} from "@ethersproject/units";

import { Contract } from '@ethersproject/contracts'
import { isAddress } from '@ethersproject/address'

import useSWR from 'swr'

import GFCABI from '../abi/GameForCrypto.abi.json'

import { fetcher } from '../util/Fetcher.js';
import { creditWeiCost, smartContractAddress } from '../util/Constants.js';

import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import theme from '../theme'

import Paper from '@material-ui/core/Paper';

import { useGamerData } from '../hooks/useGamerData';


const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
}));

export const AddCredits = (props) => {

  const classes = useStyles();

  //let address = '0x8B86Efbe8E6f0D09511DE1AbC1C0663896acFEa2';

  const { account, library } = useWeb3React();

  const [hasInit, setHasInit] = useState(false);
  const [myContract, setMyContract] = useState(null);

  const [addCreditValue, setAddCreditValue] = useState(1);
  
  const [gamerName, setGamerName] = useState("unknown");

  const gamerData = useGamerData(props.address);

  //Min Cost .0001 ETH About $0.21 at current price 3-28-21 -> -4-9-21  GK
  //const creditWeiCost = 1000000000000000;

  useEffect(() => {
    if(library && !hasInit){
      const contract = new Contract(smartContractAddress, GFCABI, library.getSigner());
      setMyContract(contract);
      setHasInit(true);
    }
    
  },[library])

  useEffect(() => {

    if(props.gamerName && props.gamerName !== gamerName){
      setGamerName(props.gamerName);
    }

  },[props.gamerName])

useEffect(() => {
  if(gamerData.hasLoaded){
    if(gamerData.hasGamerName){
      console.log(`Setting Gamer Name ${gamerData.hasGamerName}`);
      setGamerName(gamerData.hasGamerName);
    }
  }
},[gamerData, gamerData.hasLoaded])

  const attempt = () => {
    console.log('Attempt..', account);

    if(myContract !== null){
      console.log(myContract);

      //myContract.methods.getOwner().call()
      myContract['addGamerCredits'](gamerName,{
        value: creditWeiCost * addCreditValue,
      })
      .then(result => {
        console.log(`result`, result);
      })

      
    }
  }

  return (
    <Paper elevation={3}>
      <Typography variant="h5" className={classes.title}>
           Deposit Credits
          </Typography>
          <Typography variant="p" className={classes.title}>
           <p>Eth Value: .0001 x Credits</p>
          </Typography>
    <select value={addCreditValue}
    onChange={(event) => {
      setAddCreditValue(event.target.value);
    }}
    >
      <option value={10}> 10 Credits </option>
      <option value={20}> 20 Credits </option>
      <option value={30}> 30 Credits </option>
      <option value={40}> 40 Credits </option>
      <option value={50}> 50 Credits </option>
    </select>
    <button
      onClick={() => {
        attempt();
      }}
      > Add Credits </button>
    </Paper>
  )

  //Test Call Smart Contract Functions
  //0x8B86Efbe8E6f0D09511DE1AbC1C0663896acFEa2
  /*
  
  const { data: balance, mutate } = useSWR([address, 'getOwner', account], {
    fetcher: fetcher(library, GFCABI),
  })
  */
  /*
  useEffect(() => {
    // listen for changes on an Ethereum address
    console.log(`listening for Transfer...`)
    const contract = new Contract(address, ERC20ABI, library.getSigner())
    
    const fromMe = contract.filters.Transfer(account, null)

    library.on(fromMe, (from, to, amount, event) => {
      console.log('Transfer|sent', { from, to, amount, event })
      mutate(undefined, true)
    })
    const toMe = contract.filters.Transfer(null, account)
    library.on(toMe, (from, to, amount, event) => {
      console.log('Transfer|received', { from, to, amount, event })
      mutate(undefined, true)
    })
    // remove listener when the component is unmounted
    return () => {
      library.removeAllListeners(toMe)
      library.removeAllListeners(fromMe)
    }
    // trigger the effect only on component mount
  }, [])
  */
 /*
  if (!balance) {
    return <div>...</div>
  }
  return (
    <div>
      <p>Owner: {balance} </p>*/
      {/*parseFloat(formatUnits(balance, decimals)).toPrecision(4)} {symbol*/}
   /* </div>
  )*/
}